// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from 'prop-types';

// Data
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useNavigate, useMatch } from 'react-router-dom';

// Components
import MapNav from "nextus/Sidenavs/MapNav";
import ExploringMapSubgroups from "nextus/Maps/ExploringMaps/Subgroups";

// API/MODELS
import groupAPI from "api/groups";
import bksAPI from "api/bks";
import clearwaysAPI from "modules/clearways/api";
import userAPI from "api/user";

// Map
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';

// helpers
import { processDevicesData } from "helper/device";
import ExploringMapDevices from "nextus/Maps/ExploringMaps/Devices";
import { processSubgroupData } from "helper/group";
import { getUpdatedStats } from "helper/group";
import { processGroupData } from "helper/group";
import MapMenuContent from "nextus/MapMenuContent";
import { processEventsData } from "helper/event";
import { useSoftUIController } from "context";

mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function wrapper(map, content) {
    return (
        <SoftBox sx={{ width: '100%', height: '100%' }}>
            {map}
            {content}
        </SoftBox>
    )
}

function ExploreMapSubgroups({ map, navTitle, setNavTitle, sidebarState, setSidebarState }) {
    groupAPI.loadToken(useAuth0());
    bksAPI.loadToken(useAuth0());
    clearwaysAPI.loadToken(useAuth0());
    userAPI.loadToken(useAuth0());

    const { user } = useAuth0();

    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [menuToggled, setMenuToggled] = useState(true);
    const [mapPadding, setMapPadding] = useState([600, 250]);

    const [controller, dispatch] = useSoftUIController();
    const { miniSidenav, hiddenSidenav, direction, layout, openConfigurator, sidenavColor, deviceStyle } = controller;

    const [eventbarState, setEventbarState] = useState('closed');

    const { group_id } = useMatch('explore/groups/:group_id').params;

    const group = useQuery({
        queryKey: ['getGroupWithID', group_id],
        queryFn: async () => {
            return await groupAPI.getGroupWithID(group_id);
        }
    });

    const devices = useQuery({
        queryKey: ['getAllDevices'],
        queryFn: async () => {
            return await bksAPI.getAllDevices()
        }
    });

    const events = useQuery({
        queryKey: ['getAllClearways'],
        queryFn: async () => {
            return await clearwaysAPI.getAllClearways();
        },
        // staleTime: 20 * 1000
    });

    const selected_user = useQuery({
        queryKey: ['getUserByEmail', user.email.toLowerCase()],
        queryFn: async () => {
            return await userAPI.getUserByEmail(user.email.toLowerCase());
        }
    });

    useEffect(() => {
        // console.log('explore_map_view_subgroups')
        setSidebarState('exploring');
        setNavTitle(['explore map']);

        // if (menuToggled) {
        //     setMenuToggled(false);
        // }

        if (deviceStyle == 'mobile') {
            setMapPadding([0, 0]);
            // setSidebarOpen(false);
        }
        else {
            if (!sidebarOpen) {
                if (eventbarState == 'open') {
                    setMapPadding([0, 250]);
                }
                else {
                    setMapPadding([0, 0]);
                }
                setSidebarOpen(false);
            }
            else {
                if (eventbarState == 'open') {
                    setMapPadding([600, 250]);
                }
                else {
                    setMapPadding([600, 0]);
                }
                setSidebarOpen(true);
            }
        }

    }, [sidebarOpen, navTitle, deviceStyle]);

    if (group.isLoading || devices.isLoading || selected_user.isLoading || events.isLoading) {
        return wrapper('Loading...');
    }

    if (group.error || devices.error || selected_user.error) {
        if (group.error) {
            var error = group.error;
        }
        else if (devices.error) {
            var error = devices.error;
        }
        else if (selected_user.error) {
            var error = selected_user.error;
        }
        else if (events.error) {
            var error = events.error;
        }
        return wrapper("An error has occurred: " + error.message);
    }

    if (!group.data || !devices.data || !selected_user.data) {
        return wrapper('Loading...');
    }

    // if (events.isLoading) {
    //     if (group.data.subgroups.length > 0) {
    //         return wrapper(
    //             (<ExploringMapSubgroups map={map} mapPadding={mapPadding} group={group_data} user_role={selected_user.data.user.user_type} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} extraPadding={eventbarState == 'open'} />),
    //             ('Loading...')
    //         );
    //     }
    //     else {
    //         return wrapper(
    //             (<ExploringMapDevices map={map} mapPadding={mapPadding} group={group_data} user_role={selected_user.data.user.user_type} selected_group={group_data} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} extraPadding={eventbarState == 'open'} />),
    //             ('Loading...')
    //         );
    //     }
    // }

    // if (events.error) {
    //     if (group.data.subgroups.length > 0) {
    //         return wrapper(
    //             (<ExploringMapSubgroups map={map} mapPadding={mapPadding} group={group_data} user_role={selected_user.data.user.user_type} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} extraPadding={eventbarState == 'open'} />),
    //             ("An error has occurred: " + events.error.message)
    //         );
    //     }
    //     else {
    //         return wrapper(
    //             (<ExploringMapDevices map={map} mapPadding={mapPadding} group={group_data} user_role={selected_user.data.user.user_type} selected_group={group_data} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} extraPadding={eventbarState == 'open'} />),
    //             ("An error has occurred: " + events.error.message)
    //         );
    //     }
    // }

    // if (!events.data) {
    //     if (group.data.subgroups.length > 0) {
    //         return wrapper(
    //             (<ExploringMapSubgroups map={map} mapPadding={mapPadding} group={group_data} user_role={selected_user.data.user.user_type} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} extraPadding={eventbarState == 'open'} />),
    //             ('Loading...')
    //         );
    //     }
    //     else {
    //         return wrapper(
    //             (<ExploringMapDevices map={map} mapPadding={mapPadding} group={group_data} user_role={selected_user.data.user.user_type} selected_group={group_data} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} extraPadding={eventbarState == 'open'} />),
    //             ('Loading...')
    //         );
    //     }
    // }

    var events_data = processEventsData(events.data);
    events_data = events_data.filter(function (event) {
        var ret = false;
        event.groups.forEach(function (group) {
            if (group.group_id == group_id) {
                ret = true;
            }
        });

        return ret;
    });

    var group_data = processGroupData(group.data, devices.data);

    if (group.data.subgroups.length > 0) {
        return wrapper(
            (<ExploringMapSubgroups map={map} mapPadding={mapPadding} group={group_data} user_role={selected_user.data.user.user_type} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} extraPadding={events_data.length > 0} deviceStyle={deviceStyle} />),
            (<MapMenuContent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} groupPreviewID={group_id} sidebarState={'exploring'} events={events_data} eventbarState={events_data.length > 0 ? 'open' : 'closed'} setEventbarState={setEventbarState} deviceStyle={deviceStyle} />)
        );
    }
    else {
        return wrapper(
            (<ExploringMapDevices map={map} mapPadding={mapPadding} group={group_data} user_role={selected_user.data.user.user_type} selected_group={group_data} sidebarOpen={sidebarOpen} menuToggled={menuToggled} setMenuToggled={setMenuToggled} extraPadding={events_data.length > 0} deviceStyle={deviceStyle} />),
            (<MapMenuContent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} groupPreviewID={group_id} sidebarState={'exploring'} events={events_data} eventbarState={events_data.length > 0 ? 'open' : 'closed'} setEventbarState={setEventbarState} deviceStyle={deviceStyle} />)
        );
    }
}

ExploreMapSubgroups.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func
}

export default ExploreMapSubgroups;